import {stg} from "./Utils";

export default class Pic {

    static url(pic, thumb = false) {
        if (pic && stg) {
            if (pic.startsWith('http')) {
                return pic;
            } else {
                return stg.url_uploads + (thumb ? '/_' : '') + pic;
            }
        } else {
            return '';
        }
    }

}